import { get, post } from '@api/request';

export async function fetchHSAuditExport(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/export/hsauditexports`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchHSAuditExportByID(
  { appraisalService },
  authenticationToken,
  { hsAuditID },
) {
  const url = `${appraisalService}/export/hsauditexport/${hsAuditID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertHSAuditExport(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/export/hsauditexports`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export const downloadHSAuditExportFile = async (
  { appraisalService },
  authenticationToken,
  { s3ID },
) => {
  const url = `${appraisalService}/export/file/${s3ID}`;
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = `Evidence Import ${s3ID}`;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function fetchHSAuditExportProperties(
  { appraisalService },
  authenticationToken,
  { hsAuditID, page = 1, pageSize = 50 },
) {
  const url = `${appraisalService}/export/hsauditexport/${hsAuditID}/properties?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}
